export default {
  setLoading(state, loading) {
    state.loading = loading;
  },
  nextStep(state) {
    state.activeStep += 1;
  },
  backStep(state) {
    state.activeStep -= 1;
  },
  setAppConfig(state, payload) {
    state.appConfig[payload.fieldGroupName] = payload.app_config_part;
  },
  setAppConfigField(state, payload) {
    const configSection = state.appConfig[payload.app_config_section] || {};
    const perWarehouse = Array.isArray(configSection.per_warehouse)
      ? configSection.per_warehouse
      : [];

    if (payload.warehouseId) {
      let warehouseConfig = perWarehouse.find(
        config => config.warehouse_id === payload.warehouseId,
      );

      const warehouseData = state.warehouses.find(
        warehouse => warehouse.id === payload.warehouseId,
      );

      const TRANSFORMED_FEDERAL_TAX_PAYER_ID = warehouseData
        ? warehouseData.federal_tax_payer_id.replace(/\D/g, '')
        : '';

      if (!warehouseConfig) {
        warehouseConfig = {
          warehouse_id: payload.warehouseId,
          cnpj_rem: TRANSFORMED_FEDERAL_TAX_PAYER_ID,
          warehouse_name: warehouseData ? warehouseData.name : '',
        };
        perWarehouse.push(warehouseConfig);
      }

      warehouseConfig[payload.fieldName] = payload.fieldValue;
    } else {
      configSection.general = configSection.general || {};
      configSection.general[payload.fieldName] = payload.fieldValue;
    }

    configSection.per_warehouse = perWarehouse;
  },
  setAppDetails(state, appDetails) {
    state.appDetails = appDetails;
  },
  setWarehouses(state, warehouses) {
    state.warehouses = warehouses;
  },
  setContact(state, contact) {
    state.contact = contact;
  },
  setSelfServiceList(state, selfServiceList) {
    state.selfServiceList = selfServiceList;
  },
  setSelfServiceListSearched(state, searchedAppList) {
    state.searchedAppList = searchedAppList;
  },
  setAppSelfServiceWithoutFilter(state, appSelfServiceWithoutFilter = []) {
    state.appSelfServiceWithoutFilter = appSelfServiceWithoutFilter;
  },
  includeWarehouse(state, warehouse) {
    state.includedWarehouses.push(warehouse);
  },
  clearAppNameFilterFieldValue(state, appNameFilterFieldValue = '') {
    state.appNameFilterFieldValue = appNameFilterFieldValue;
  },
  removeWarehouse(state, warehouse) {
    state.includedWarehouses = state.includedWarehouses
      .filter(row => row.id !== warehouse.id);
  },
  setInstallationId(state, installationId) {
    state.installationId = installationId;
  },
  setLpRequestData(state, lpRequestData) {
    state.lpRequestData = lpRequestData;
  },
  setLogisticProviderList(state, logisticProviderList) {
    state.logisticProviderList = logisticProviderList;
  },
  setModal(state, modal) {
    state.modal = modal;
  },
  setClientInfo(state, clientInfo) {
    state.clientInfo = clientInfo;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/store/mutations.js